import { css } from '@emotion/css';

export const actionDropdownClassName = css({
  cursor: 'pointer',
});
